<div class="form-group mb-0 position-relative">
  <input
    class="form-control flex-grow-1"
    id="datatable_filter"
    [placeholder]="'datatable.filter.label' | translate"
    [portalAutofocus]="true"
    [value]="filter$ | async"
    (input)="onSearchInput($event.target)"
    autocomplete="off"
    type="text"
  />

  @if (filter$ | async) {
    <portal-icon-button class="dataTable-filter__clear" (click)="search('')" iconClass="far fa-times">
    </portal-icon-button>
  }
</div>
